import { Box, Container, Stack, Typography } from '@mui/material';
import Logo from 'components-new/common/logo';
import ShareButtons from './navbar/ShareButtons';

type Props = {
  whitelabel: any;
};

export function Footer({ whitelabel }: Props) {
  return (
    <Box sx={{ width: '100%', px: 2, py: 1, background: '#fff' }}>
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: { md: 'row', xs: 'column-reverse' },
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          mt={{
            md: 0,
            xs: 1.5,
          }}
        >
          <Typography variant="body2">Powered by</Typography>
          <Logo href={whitelabel?.website} src={whitelabel?.logo} maxHeight={30} />
        </Stack>

        <ShareButtons />
      </Container>
    </Box>
  );
}
